var _path, _g, _path2, _path3, _path4, _circle, _path5, _circle2, _path6, _circle3, _path7, _circle4, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg024Globalnetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bold",
    enableBackground: "new 0 0 32 32",
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26 32h-20c-3.314 0-6-2.686-6-6v-20c0-3.314 2.686-6 6-6h20c3.314 0 6 2.686 6 6v20c0 3.314-2.686 6-6 6z",
    fill: "#fff9dd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffe777"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.193 11.346c-.153 0-.304-.07-.402-.202-.165-.222-.118-.535.104-.7.905-.671 1.969-1.111 3.078-1.272.278-.038.527.149.567.423.04.273-.15.527-.423.567-.946.138-1.855.513-2.628 1.086-.089.066-.193.098-.296.098z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.333 15.545c-.244 0-.458-.179-.494-.428-.137-.947-.513-1.855-1.087-2.626-.164-.222-.118-.535.104-.7.223-.165.535-.118.7.103.671.904 1.111 1.969 1.273 3.079.04.273-.15.527-.423.567-.025.003-.049.005-.073.005z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.954 22.833c-.244 0-.458-.179-.494-.428-.04-.273.15-.527.423-.567.946-.138 1.855-.513 2.628-1.086.221-.165.535-.118.699.104.165.222.118.535-.104.7-.905.671-1.969 1.111-3.078 1.272-.025.004-.049.005-.074.005z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.847 20.308c-.153 0-.304-.07-.402-.202-.671-.904-1.111-1.969-1.273-3.079-.04-.273.15-.527.423-.567.27-.037.527.15.566.423.137.947.513 1.855 1.087 2.626.164.222.118.535-.104.7-.089.066-.194.099-.297.099z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.667 15.545c-.024 0-.048-.002-.072-.005-.273-.04-.463-.293-.423-.567.161-1.11.602-2.175 1.273-3.079.165-.222.477-.268.7-.103.221.165.268.478.104.7-.574.771-.949 1.68-1.087 2.626-.037.249-.251.428-.495.428z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.046 22.833c-.024 0-.048-.002-.073-.005-1.109-.161-2.173-.602-3.078-1.272-.222-.164-.269-.478-.104-.7.165-.221.478-.269.699-.104.773.573 1.682.949 2.628 1.086.273.04.462.294.423.567-.038.249-.251.428-.495.428z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.153 20.308c-.104 0-.208-.032-.298-.099-.221-.165-.268-.478-.104-.7.574-.771.949-1.68 1.087-2.626.04-.273.299-.461.566-.423.273.04.463.293.423.567-.161 1.11-.602 2.175-1.273 3.079-.097.132-.248.202-.401.202z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.807 11.346c-.104 0-.208-.032-.297-.098-.773-.573-1.682-.949-2.628-1.086-.273-.04-.462-.294-.423-.567.04-.273.29-.462.567-.423 1.109.161 2.173.602 3.078 1.272.222.164.269.478.104.7-.097.132-.248.202-.401.202z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.25 18.333h-1.417c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h1.417c.23 0 .417-.187.417-.417s-.187-.417-.417-.417h-.5c-.781 0-1.417-.635-1.417-1.417 0-.781.635-1.417 1.417-1.417h1.417c.276 0 .5.224.5.5s-.224.5-.5.5h-1.417c-.23 0-.417.187-.417.417s.187.417.417.417h.5c.781 0 1.417.635 1.417 1.417s-.636 1.417-1.417 1.417z",
    fill: "#ffd200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m16 14.667c-.276 0-.5-.224-.5-.5v-1.333c0-.276.224-.5.5-.5s.5.224.5.5v1.333c0 .276-.224.5-.5.5z",
    fill: "#ffd200"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m16 19.667c-.276 0-.5-.224-.5-.5v-1.333c0-.276.224-.5.5-.5s.5.224.5.5v1.333c0 .276-.224.5-.5.5z",
    fill: "#ffd200"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 9.333,
    fill: "#ffe777",
    r: 1.333
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m20.714 12.618c.341 0 .683-.13.943-.389.52-.52.52-1.366 0-1.886-.52-.519-1.366-.519-1.885 0-.52.52-.52 1.366 0 1.886.259.26.601.389.942.389z",
    fill: "#ffe777"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.667,
    cy: 16,
    fill: "#ffe777",
    r: 1.333
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m19.772 19.771c-.52.52-.52 1.366 0 1.886.26.259.602.389.943.389s.683-.13.943-.39c.52-.52.52-1.366 0-1.886-.521-.518-1.367-.518-1.886.001z",
    fill: "#ffe777"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 22.667,
    fill: "#ffe777",
    r: 1.333
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m10.343 19.771c-.52.52-.52 1.366 0 1.886.26.259.602.389.943.389s.683-.13.943-.39c.52-.52.52-1.366 0-1.886-.52-.518-1.366-.518-1.886.001z",
    fill: "#ffe777"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.333,
    cy: 16,
    fill: "#ffe777",
    r: 1.333
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m12.228 10.343c-.52-.519-1.366-.519-1.885 0-.52.52-.52 1.366 0 1.886.26.259.602.389.943.389s.683-.13.943-.39c.52-.519.52-1.365-.001-1.885z",
    fill: "#ffe777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg024Globalnetwork);
export default __webpack_public_path__ + "static/media/024-global network.2831a67c2be180fa512fbffe01403df5.svg";
export { ForwardRef as ReactComponent };